<template>
  <div class="search-form">
    <form
      v-on:submit.prevent="startSearch({ skipTimeout: true })"
      role="search"
    >
      <div class="search-form__desktop">
        <input
          class="search-form__desktop--form"
          type="text"
          autocorrect="off"
          autocapitalize="off"
          placeholder="Search..."
          @focus="userSearchQuery = ''"
          v-model="userSearchQuery"
          @keyup="isSearchActive ? startSearch({ skipTimeout: false }) : null"
          autocomplete="off"
          tabindex="0"
        />
        <MagnifyingGlassIcon
          @click="startSearch({ skipTimeout: true })"
          class="search-form__search-icon"
        />
      </div>
    </form>
    <form
      v-on:submit.prevent="startSearch({ skipTimeout: true })"
      class="search-form__mobile"
      role="search"
    >
      <input
        class="search-form__mobile--form"
        type="text"
        autocorrect="off"
        autocapitalize="off"
        @focus="userSearchQuery = ''"
        v-model="userSearchQuery"
        autocomplete="off"
        tabindex="0"
        placeholder="Enter search query..."
        @keyup="isSearchActive ? startSearch({ skipTimeout: false }) : null"
      />
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MagnifyingGlassIcon from '@/assets/icons/search/magnifying_glass.svg'

export default {
  name: 'SearchForm',
  data() {
    return {
      userSearchQuery: '',
      timeout: null,
    }
  },
  components: {
    MagnifyingGlassIcon: {
      ...MagnifyingGlassIcon,
      name: 'MagnifyingGlassIcon',
    },
  },
  computed: {
    ...mapState({
      searchQuery: state => state.search.searchQuery,
    }),
    isSearchActive() {
      return this.userSearchQuery.length >= 3
    },
  },
  watch: {
    searchQuery(query) {
      if (query === '') {
        this.userSearchQuery = ''
      }
    },
  },
  methods: {
    startSearch({ skipTimeout }) {
      if (!skipTimeout) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$store.dispatch('search/setQuery', this.userSearchQuery)
          if (this.$route.name !== 'search') {
            this.$router.push({ name: 'search' })
          }
        }, 500)
      } else {
        this.$store.dispatch('search/setQuery', this.userSearchQuery)
        if (this.$route.name !== 'search') {
          this.$router.push({ name: 'search' })
        }
      }
    },
    close() {
      this.$emit('closed', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.search-form {
  $this: &;
  &__desktop {
    position: relative;
    display: none;
    @include tablet {
      display: block;
    }
    &--form {
      background-color: var(--black);
      opacity: 0.8;
      border: none;
      border-radius: 35px;
      width: 250px;
      color: var(--white);
      padding: 12px 30px;
      @include tablet {
        width: 300px;
      }
      @include desktop {
        width: 350px;
      }
      &:focus {
        background-color: var(--light-gray);
      }
    }
  }
  &__search-icon {
    position: absolute;
    top: 11px;
    right: 20px;
    font-size: 1.7rem;
    fill: var(--white);
    transition: 0.5s all ease;
    &:hover {
      cursor: pointer;
      fill: var(--orange);
      transform: scale(1.05);
    }
  }
  &__mobile {
    @keyframes fadeAnim {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    position: absolute;
    top: 0;
    left: 0;
    animation: fadeAnim 0.5s ease;
    transition: 0.3s all ease;
    display: block;
    @include tablet {
      display: none;
    }
    &--form {
      width: 88vw;
      height: 20px;
      font-size: 1rem;
      padding: 20px 20px;
    }
  }
}
</style>
